<template>
  <div v-if="visible" id="me-promo-strip">
    <a
      v-if="current?.link_url"
      :href="current.link_url"
      target="_blank"
      rel="noopener"
    >
      <img :src="currentSrc" :alt="current.title || ''" />
    </a>
    <img
      v-else-if="current"
      :src="currentSrc"
      :alt="current.title || ''"
    />
    <div v-if="banners.length > 1" class="me-promo-dots">
      <button
        v-for="(banner, i) in banners"
        :key="banner.id || i"
        type="button"
        :class="{ active: i === index }"
        :aria-label="banner.title || `Banner ${i + 1}`"
        @click="index = i"
      />
    </div>
  </div>
</template>
<style scoped>
#me-promo-strip {
  height: 100px;
  width: 100%;
  overflow: hidden;
  position: relative;
  background: transparent;
}
#me-promo-strip img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.me-promo-dots {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 6px;
  display: flex;
  justify-content: center;
  gap: 6px;
  z-index: 1;
}
.me-promo-dots button {
  width: 8px;
  height: 8px;
  padding: 0;
  border: 0;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.35);
  cursor: pointer;
}
.me-promo-dots button.active {
  background: rgba(0, 0, 0, 0.8);
}
@media (max-width: 767px) {
  #me-promo-strip {
    height: 72px;
  }
}
</style>
<script>
import api from '@/services'

export default {
  name: 'PromoBannerStrip',
  setup() {
    return { api }
  },
  data() {
    return {
      banners: [],
      settings: { enabled: false, rotation_minutes: 5 },
      index: 0,
      isMobile: typeof window !== 'undefined' ? window.innerWidth < 768 : false,
      rotationTimer: null,
    }
  },
  created() {
    this.loadActive()
  },
  mounted() {
    window.addEventListener('resize', this.onResize)
  },
  beforeUnmount() {
    this.clearRotation()
    window.removeEventListener('resize', this.onResize)
  },
  methods: {
    shouldShow() {
      return api.auth.isLoggedIn()
        && this.$route?.name !== 'Auth'
        && !api.lgpd.isPublicPath(this.$route?.path)
    },
    onResize() {
      this.isMobile = window.innerWidth < 768
    },
    clearRotation() {
      if (this.rotationTimer) {
        clearInterval(this.rotationTimer)
        this.rotationTimer = null
      }
    },
    startRotation() {
      this.clearRotation()
      if (this.banners.length < 2 || !this.settings?.enabled) return
      const minutes = Math.max(1, Number(this.settings.rotation_minutes) || 1)
      this.rotationTimer = setInterval(() => {
        this.index = (this.index + 1) % this.banners.length
      }, minutes * 60 * 1000)
    },
    loadActive() {
      if (!this.shouldShow()) {
        this.banners = []
        this.settings = { enabled: false, rotation_minutes: 5 }
        this.clearRotation()
        return
      }
      return api.promoBanner.active()
        .then((payload) => {
          const banners = payload?.banners || []
          const settings = payload?.settings || { enabled: false, rotation_minutes: 5 }
          this.settings = settings
          this.banners = Array.isArray(banners) ? banners : []
          if (this.index >= this.banners.length) this.index = 0
          this.startRotation()
        })
        .catch((err) => {
          console.warn(err)
          this.banners = []
          this.settings = { enabled: false, rotation_minutes: 5 }
          this.clearRotation()
        })
    },
  },
  computed: {
    routeKey() {
      return `${this.$route?.name || ''}:${this.$route?.fullPath || ''}`
    },
    visible() {
      return this.shouldShow()
        && !!this.settings?.enabled
        && this.banners.length > 0
    },
    current() {
      return this.banners[this.index] || null
    },
    currentSrc() {
      const banner = this.current
      if (!banner) return ''
      if (this.isMobile) return banner.image_mobile || banner.image_desktop || ''
      return banner.image_desktop || banner.image_mobile || ''
    },
  },
  watch: {
    routeKey() {
      this.loadActive()
    },
  },
}
</script>
